//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useContext } from 'react';
import './styles.scss';
import { MultiCheckContext } from './context';
import cn from 'classnames';
import { ReactComponent as ActiveSVG } from '../../../assets/images/check.svg';
import { ReactComponent as InactiveSVG } from '../../../assets/images/Subtract.svg';
import { Text } from '../../typography/Text/Text';

export const MultiOption = ({ children, value }) => {
  const { handleChange, currentValue } = useContext(MultiCheckContext);

  const isActive = currentValue.findIndex((v) => v === value) !== -1;

  return (
    <div
      className={cn('multi-option', { 'multi-active': isActive })
      }
      onClick={() => {
        handleChange(value);
      }}
    >
      <Text semibold className={'option-text'}>
        {children}
      </Text>
      {currentValue.findIndex((v) => v === value) !== -1 ? (
        <ActiveSVG />
      ) : (
        <InactiveSVG />
      )}
    </div>
  );
};
